import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// React Router doesn't auto-scroll to a #hash on client-side navigation the
// way a full page load does. This makes nav links like "/#our-work" work
// correctly even when clicked from a different page (e.g. /artists).
export default function ScrollToHash() {
  const { hash, pathname } = useLocation();

  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      // small delay lets the destination page finish rendering first
      const timer = setTimeout(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: "smooth", block: "start" });
      }, 80);
      return () => clearTimeout(timer);
    }
    window.scrollTo(0, 0);
  }, [hash, pathname]);

  return null;
}
